<template>
  <div class="profile text-center">
    <TopMenu
      :title="$t('PROFILE.PAGE_LABEL')"
      back-to="/dashboard"
      dark-background/>
    <div class="container-fluid content">
      <div
        v-for="(menu, index) in menus"
        :key="index">
        <div class="row-item-transparent-with-border mt-4 mb-3 pr-4 pl-4 text-left">
          <h3>{{ $t(menu.text) }}</h3>
        </div>
        <SubMenuItem
          v-for="(subMenu, subIndex) in menu.subMenus"
          :key="subIndex"
          :to="subMenu.to"
          :icon="subMenu.icon"
          class="pt-1 pl-4">{{ $t(subMenu.text) }}</SubMenuItem>
      </div>
      <SubMenuItem
        icon="far fa-sign-out-alt"
        class="mt-5 mb-3 pl-4"
        @click="showConfirmLogout = true">{{ $t('PROFILE.LOGOUT.MENU_TITLE') }}</SubMenuItem>
    </div>
    <BottomMenu />
    <ConfirmModal
      v-if="showConfirmLogout"
      size="md"
      show-modal
      @cancel="showConfirmLogout = false"
      @confirm="confirmLogout">{{ $t("PROFILE.LOGOUT.CONFIRM_MODAL_TEXT") }}</ConfirmModal>
  </div>
</template>

<script>
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import ProfileMenus from '@/ProfileMenus.json';
import SubMenuItem from '@/components/Menu/SubMenuItem';

export default {
  name: 'Profile',
  components: {
    ActionButton,
    TextLink,
    TopMenu,
    BottomMenu,
    ConfirmModal,
    SubMenuItem,
  },
  data() {
    return {
      showConfirmLogout: false,
      menus: ProfileMenus,
    };
  },
  methods: {
    confirmLogout() {
      this.$store.dispatch('user/logout');
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
